<ng-container *ngIf="((shoppingCart$ | async)?.items?.articles?.length ?? 0) > 0">

    <ng-container *ngIf="minimumMerchandiseValue > shoppingCartMerchandiseValue">
        <div class="container-delivery-tour-minimum-order-value">
            <p class="is-size-6">
                Mindestbestellwert {{ NumberFormat(minimumMerchandiseValue, (config$ | async)?.currency) }}</p>
            <progress class="progress is-warning mb-0" value="{{MathRound(shoppingCartMerchandiseValue)}}"
                      max="{{MathRound(minimumMerchandiseValue)}}"></progress>
            <p class="is-size-7">Aktueller
                Warenkorb: {{ NumberFormat(shoppingCartMerchandiseValue, (config$ | async)?.currency) }}</p>
            <p *ngIf="deliveryTour?.minimumMerchandiseValue?.excludedGroups?.length ?? 0 > 0" class="is-size-7">Folgende
                Gruppen sind bei der Ermittlung
                ausgeschlossen: {{ deliveryTour?.minimumMerchandiseValue?.excludedGroups?.join(", ") }}.</p>
            <div *ngIf="deliveryTour?.minimumMerchandiseValue?.note" [innerHTML]="deliveryTour?.minimumMerchandiseValue?.note"></div>
        </div>
    </ng-container>
    <ng-container *ngIf="minimumArticles > shoppingCartArticles ">
        <div class="container-delivery-tour-minimum-order-value">
            <p class="is-size-6">Mindestabnahme {{ minimumArticles }} Artikel</p>
            <progress class="progress is-warning mb-0" value="{{shoppingCartArticles}}" max="{{minimumArticles}}">
            </progress>
            <p class="is-size-7">{{ shoppingCartArticles }} Artikel im Warenkorb</p>
            <p *ngIf="deliveryTour?.minimumArticles?.excludedGroups?.length ?? 0 > 0" class="is-size-7">Folgende Gruppen
                sind bei der Ermittlung ausgeschlossen: {{ deliveryTour?.minimumArticles?.excludedGroups?.join(", ") }}
                .</p>
            <p *ngIf="deliveryTour?.minimumArticles?.requiredArticleUnitTypes?.length ?? 0 > 0" class="is-size-7">
                Ausschließlich folgende Gebinde-Typen werden
                berücksichtigt: {{ deliveryTour?.minimumArticles?.requiredArticleUnitTypes?.join(", ") }}.</p>
            <div *ngIf="deliveryTour?.minimumArticles?.note" [innerHTML]="deliveryTour?.minimumArticles?.note"></div>
        </div>
    </ng-container>

</ng-container>

